/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

import isInputCorrect from "src/utils/ResultValidationHelper";

import Card from "src/components/cards/Card.react";
import ResultDropdown from "src/components/dropdowns/Result.react";

import {
  Table,
  ColHeader,
  TableBody,
  Col,
} from "src/components/tables/Table.react";
import ResultBadge from "src/components/badges/Result.react";
import PrintHeader from "src/components/print/PrintHeader.react";

/**
 * The Yaw component
 *
 * @author Thais Watanabe
 */
const Yaw = (props) => {
  const {
    turbineInspection,
    inspectionModel,
    inspectionModelItems,
    results,
    lastResults,
    lastTurbineInspections,
    openEdit,
    openObs,
    inspection,
  } = props;

  const lastOneYear = lastTurbineInspections.find((obj) =>
    obj.inspection.type.startsWith("1年")
  );

  // 3-3
  const i3_3 = inspectionModelItems.filter((obj) => obj.name === "3-3")?.[0];
  const r3_3 = results.filter((obj) => obj.itemId === "3-3")?.[0];

  // 3-4
  const i3_4 = inspectionModelItems.filter((obj) => obj.name === "3-4")?.[0];
  const r3_4 = results.filter((obj) => obj.itemId === "3-4")?.[0];

  // 3-6
  const i3_6 = inspectionModelItems.filter((obj) => obj.name === "3-6")?.[0];
  const i3_6_1 = i3_6?.inspectionModelItemChildren.items
    .filter((_, i) => i % 2 === 0)
    .slice(1);

  const i3_6_2 = i3_6?.inspectionModelItemChildren.items.filter(
    (_, i) => i % 2 === 1
  );
  const r3_6 = results.filter((obj) => obj.itemId === "3-6")?.[0];
  const r3_6_1 = r3_6?.childrenResults.filter((_, i) => i % 2 === 0);
  const r3_6_2 = r3_6?.childrenResults.filter((_, i) => i % 2 === 1);

  const last_r3_6 = lastResults?.filter(
    (obj) => obj.itemId === "3-6" && obj.turbineInspectionID === lastOneYear
  )?.[0];
  const last_r3_6_1 = last_r3_6?.childrenResults.filter((_, i) => i % 2 === 0);

  // Last inspection
  const lastInspection = lastTurbineInspections.find(
    (el) => el.id === last_r3_6?.turbineInspectionID
  );

  // 3-8
  const i3_8 = inspectionModelItems.filter((obj) => obj.name === "3-8")?.[0];
  const r3_8 = results.filter((obj) => obj.itemId === "3-8")?.[0];
  const last_r3_8 = lastResults?.filter(
    (obj) => obj.itemId === "3-8" && obj.turbineInspectionID === lastOneYear
  )?.[0];

  // 3-9
  const i3_9 = inspectionModelItems.filter((obj) => obj.name === "3-9")?.[0];
  const r3_9 = results.filter((obj) => obj.itemId === "3-9")?.[0];
  const r3_9_1 = r3_9?.childrenResults.filter((_, i) => i % 2 === 0);
  const r3_9_2 = r3_9?.childrenResults.filter((_, i) => i % 2 === 1);

  const last_r3_9 = lastResults?.filter(
    (obj) => obj.itemId === "3-9" && obj.turbineInspectionID === lastOneYear
  )?.[0];
  const last_r3_9_1 = last_r3_9?.childrenResults.filter((_, i) => i % 2 === 0);
  const last_r3_9_2 = last_r3_9?.childrenResults.filter((_, i) => i % 2 === 1);

  // 3-14
  const i3_14 = inspectionModelItems.filter((obj) => obj.name === "3-14")?.[0];
  const r3_14 = results.filter((obj) => obj.itemId === "3-14")?.[0];
  const last_r3_14_1 = lastResults?.filter((obj) => obj.itemId === "3-14")?.[0];
  const last_r3_14_2 = lastResults?.filter((obj) => obj.itemId === "3-14")?.[1];

  return (
    <div className="pagebreak">
      <Card>
        <PrintHeader
          inspectionModel={inspectionModel}
          inspection={inspection}
          turbineInspection={turbineInspection}
        />

        <Table className="print:mb-2">
          <thead>
            <tr>
              <ColHeader colSpan={19}>
                ヨーブレーキシステム外部・内部確認
              </ColHeader>
            </tr>
            <tr>
              <ColHeader className="w-10 print:hidden"></ColHeader>
              <ColHeader>No</ColHeader>
              {i3_3?.inspectionModelItemChildren.items.map(
                (itemChild, x) =>
                  x !== 0 && (
                    <ColHeader key={x} className="text-center">
                      {itemChild.name.slice(3)}
                    </ColHeader>
                  )
              )}
            </tr>
          </thead>
          <TableBody>
            <tr>
              <ColHeader id="3-3" className="print:hidden">
                <ResultDropdown
                  turbineInspection={turbineInspection}
                  openEdit={openEdit}
                  openObs={openObs}
                  selectedItem={i3_3}
                  selectedResult={r3_3}
                  lastTurbineInspections={lastTurbineInspections}
                  inspection={inspection}
                />
              </ColHeader>
              <ColHeader>外部</ColHeader>
              {i3_3?.inspectionModelItemChildren.items.map(
                (_, x) =>
                  x !== 0 && (
                    <Col key={x} className="text-center">
                      <ResultBadge result={r3_3?.childrenResults[x] ?? "-"} />
                    </Col>
                  )
              )}
            </tr>
            <tr>
              <ColHeader id="3-4" className="print:hidden">
                <ResultDropdown
                  turbineInspection={turbineInspection}
                  openEdit={openEdit}
                  openObs={openObs}
                  selectedItem={i3_4}
                  selectedResult={r3_4}
                  lastTurbineInspections={lastTurbineInspections}
                  inspection={inspection}
                />
              </ColHeader>
              <ColHeader>内部</ColHeader>
              {i3_4?.inspectionModelItemChildren.items.map(
                (_, x) =>
                  x !== 0 && (
                    <Col key={x} className="text-center">
                      <ResultBadge result={r3_4?.childrenResults[x] ?? "-"} />
                    </Col>
                  )
              )}
            </tr>
          </TableBody>
        </Table>
      </Card>

      <Card>
        <Table className="print:mb-2">
          <thead>
            <tr>
              <ColHeader colSpan={19}>
                ブレーキパット厚み確認　(単位:mm)
              </ColHeader>
            </tr>
            <tr>
              <ColHeader id="3-6" className="w-10 print:hidden">
                <ResultDropdown
                  turbineInspection={turbineInspection}
                  openEdit={openEdit}
                  openObs={openObs}
                  selectedItem={i3_6}
                  selectedResult={r3_6}
                  lastTurbineInspections={lastTurbineInspections}
                  inspection={inspection}
                />
              </ColHeader>
              <ColHeader className="w-10">No</ColHeader>
              {i3_6_1?.map((_, x) => (
                <ColHeader key={x} className="text-center">
                  {x + 1}
                </ColHeader>
              ))}
            </tr>
          </thead>
          <TableBody>
            <tr>
              <ColHeader className="print:hidden"></ColHeader>
              <ColHeader>厚み</ColHeader>
              {i3_6_1?.map((_, x) => (
                <Col key={x} className="text-center">
                  <ResultBadge
                    result={r3_6_1?.[x] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-6",
                      r3_6_1?.[x] ?? "-",
                      x
                    )}
                  />
                </Col>
              ))}
            </tr>
            <tr>
              <ColHeader className="print:hidden"></ColHeader>
              <ColHeader>交換</ColHeader>
              {i3_6_2?.map((_, x) => (
                <Col key={x} className="text-center">
                  <ResultBadge result={r3_6_2?.[x] ?? "-"} />
                </Col>
              ))}
            </tr>
            <tr>
              <ColHeader className="print:hidden"></ColHeader>
              <ColHeader>
                {lastInspection?.inspection?.name ?? "過去"} <br />
                厚み
              </ColHeader>
              {i3_6_2?.map((_, x) => (
                <Col key={x} className="text-center">
                  <ResultBadge
                    result={last_r3_6_1?.[x] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-6",
                      last_r3_6_1?.[x] ?? "-",
                      x
                    )}
                  />
                </Col>
              ))}
            </tr>
          </TableBody>
        </Table>
      </Card>

      <Card>
        <Table className="print:mb-2">
          <thead>
            <tr>
              <ColHeader colSpan={6}>ヨーモータ 絶縁測定結果表</ColHeader>
            </tr>
            <tr>
              <ColHeader id="3-8" className="w-10 print:hidden">
                <ResultDropdown
                  turbineInspection={turbineInspection}
                  openEdit={openEdit}
                  openObs={openObs}
                  selectedItem={i3_8}
                  selectedResult={r3_8}
                  lastTurbineInspections={lastTurbineInspections}
                  inspection={inspection}
                />
              </ColHeader>
              <ColHeader colSpan={4} className="text-center">
                今回
              </ColHeader>
              <ColHeader className="text-center">
                {lastInspection?.inspection?.name ?? "過去"}時
              </ColHeader>
            </tr>
            <tr>
              <ColHeader className="print:hidden"></ColHeader>
              <ColHeader className="text-center">モータNo</ColHeader>
              <ColHeader className="text-center">操作ブレーカー</ColHeader>
              <ColHeader className="text-center">試験電圧</ColHeader>
              <ColHeader className="text-center w-56">絶縁抵抗値</ColHeader>
              <ColHeader className="text-center w-56">絶縁抵抗値</ColHeader>
            </tr>
          </thead>
          <TableBody>
            <tr>
              <Col className="print:hidden"></Col>
              <Col className="text-center">M13.1</Col>
              <Col className="text-center">Q13.2</Col>
              <Col className="text-center" rowSpan={5}>
                500V
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={r3_8?.childrenResults[0] ?? "-"}
                  unit={i3_8?.inspectionModelItemChildren?.items?.[0].unit}
                  isInputCorrect={isInputCorrect(
                    "3-8",
                    r3_8?.childrenResults[0] ?? "-",
                    0
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r3_8?.childrenResults[0] ?? "-"}
                  unit={i3_8?.inspectionModelItemChildren?.items?.[0].unit}
                  isInputCorrect={isInputCorrect(
                    "3-8",
                    last_r3_8?.childrenResults[0] ?? "-",
                    0
                  )}
                />
              </Col>
            </tr>
            <tr>
              <Col className="print:hidden"></Col>
              <Col className="text-center">M13.3</Col>
              <Col className="text-center">Q13.3</Col>
              <Col className="text-center">
                <ResultBadge
                  result={r3_8?.childrenResults[1] ?? "-"}
                  unit={i3_8?.inspectionModelItemChildren?.items?.[0].unit}
                  isInputCorrect={isInputCorrect(
                    "3-8",
                    r3_8?.childrenResults[1] ?? "-",
                    1
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r3_8?.childrenResults[1] ?? "-"}
                  unit={i3_8?.inspectionModelItemChildren?.items?.[0].unit}
                  isInputCorrect={isInputCorrect(
                    "3-8",
                    last_r3_8?.childrenResults[1] ?? "-",
                    1
                  )}
                />
              </Col>
            </tr>
            <tr>
              <Col className="print:hidden"></Col>
              <Col className="text-center">M13.5</Col>
              <Col className="text-center">Q13.5</Col>
              <Col className="text-center">
                <ResultBadge
                  result={r3_8?.childrenResults[2] ?? "-"}
                  unit={i3_8?.inspectionModelItemChildren?.items?.[0].unit}
                  isInputCorrect={isInputCorrect(
                    "3-8",
                    r3_8?.childrenResults[2] ?? "-",
                    2
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r3_8?.childrenResults[2] ?? "-"}
                  unit={i3_8?.inspectionModelItemChildren?.items?.[0].unit}
                  isInputCorrect={isInputCorrect(
                    "3-8",
                    last_r3_8?.childrenResults[2] ?? "-",
                    2
                  )}
                />
              </Col>
            </tr>
            <tr>
              <Col className="print:hidden"></Col>
              <Col className="text-center">M13.7</Col>
              <Col className="text-center">Q13.7</Col>
              <Col className="text-center">
                <ResultBadge
                  result={r3_8?.childrenResults[3] ?? "-"}
                  unit={i3_8?.inspectionModelItemChildren?.items?.[0].unit}
                  isInputCorrect={isInputCorrect(
                    "3-8",
                    r3_8?.childrenResults[3] ?? "-",
                    3
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r3_8?.childrenResults[3] ?? "-"}
                  unit={i3_8?.inspectionModelItemChildren?.items?.[0].unit}
                  isInputCorrect={isInputCorrect(
                    "3-8",
                    last_r3_8?.childrenResults[3] ?? "-",
                    3
                  )}
                />
              </Col>
            </tr>
            <tr>
              <Col className="print:hidden"></Col>
              <Col className="text-center">M14.1</Col>
              <Col className="text-center">Q14.2</Col>
              <Col className="text-center">
                <ResultBadge
                  result={r3_8?.childrenResults[4] ?? "-"}
                  unit={i3_8?.inspectionModelItemChildren?.items?.[0].unit}
                  isInputCorrect={isInputCorrect(
                    "3-8",
                    r3_8?.childrenResults[4] ?? "-",
                    4
                  )}
                />
              </Col>
              <Col className="text-center">
                <ResultBadge
                  result={last_r3_8?.childrenResults[4] ?? "-"}
                  unit={i3_8?.inspectionModelItemChildren?.items?.[0].unit}
                  isInputCorrect={isInputCorrect(
                    "3-8",
                    last_r3_8?.childrenResults[4] ?? "-",
                    4
                  )}
                />
              </Col>
            </tr>
          </TableBody>
        </Table>
      </Card>

      <div className="pagebreak">
        <PrintHeader
          inspectionModel={inspectionModel}
          inspection={inspection}
          turbineInspection={turbineInspection}
        />

        <Card>
          <Table className="print:mb-2">
            <thead>
              <tr>
                <ColHeader colSpan={7}>
                  ヨーモータブレーキギャップ測定結果表
                </ColHeader>
              </tr>
              <tr>
                <ColHeader id="3-9" rowSpan={2} className="w-10 print:hidden">
                  <ResultDropdown
                    turbineInspection={turbineInspection}
                    openEdit={openEdit}
                    openObs={openObs}
                    selectedItem={i3_9}
                    selectedResult={r3_9}
                    lastTurbineInspections={lastTurbineInspections}
                    inspection={inspection}
                  />
                </ColHeader>
                <ColHeader className="text-center" rowSpan={2}>
                  モータNo
                </ColHeader>
                <ColHeader className="text-center" rowSpan={2}>
                  測定箇所
                </ColHeader>
                <ColHeader colSpan={2} className="text-center">
                  今回
                </ColHeader>
                <ColHeader colSpan={2} className="text-center">
                  {lastInspection?.inspection?.name ?? "過去"}
                </ColHeader>
              </tr>
              <tr>
                <ColHeader className="text-center">
                  初期
                  <br /> 測定値mm
                </ColHeader>
                <ColHeader className="text-center">
                  交換後
                  <br /> 測定値mm
                </ColHeader>
                <ColHeader className="text-center">
                  初期
                  <br /> 測定値mm
                </ColHeader>
                <ColHeader className="text-center">
                  交換後
                  <br /> 測定値mm
                </ColHeader>
              </tr>
            </thead>
            <TableBody>
              <tr>
                <Col className="text-center print:hidden" rowSpan={20}></Col>
                <Col className="text-center" rowSpan={4}>
                  M13.1
                </Col>
                <Col className="text-center">No1</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_1?.[0] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_1?.[0] ?? "-",
                      0
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_2?.[0] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_2?.[0] ?? "-",
                      0
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_1?.[0] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_1?.[0] ?? "-",
                      0
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_2?.[0] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_2?.[0] ?? "-",
                      0
                    )}
                  />
                </Col>
              </tr>
              <tr>
                <Col className="text-center">No2</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_1?.[1] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_1?.[1] ?? "-",
                      1
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_2?.[1] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_2?.[1] ?? "-",
                      1
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_1?.[1] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_1?.[1] ?? "-",
                      1
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_2?.[1] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_2?.[1] ?? "-",
                      1
                    )}
                  />
                </Col>
              </tr>
              <tr>
                <Col className="text-center">No3</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_1?.[2] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_1?.[2] ?? "-",
                      2
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_2?.[2] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_2?.[2] ?? "-",
                      2
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_1?.[2] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_1?.[2] ?? "-",
                      2
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_2?.[2] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_2?.[2] ?? "-",
                      2
                    )}
                  />
                </Col>
              </tr>
              <tr>
                <Col className="text-center">No4</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_1?.[3] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_1?.[3] ?? "-",
                      3
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_2?.[3] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_2?.[3] ?? "-",
                      3
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_1?.[3] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_1?.[3] ?? "-",
                      3
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_2?.[3] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_2?.[3] ?? "-",
                      3
                    )}
                  />
                </Col>
              </tr>
              {/*  */}
              <tr>
                <Col className="text-center" rowSpan={4}>
                  M13.3
                </Col>
                <Col className="text-center">No1</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_1?.[4] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_1?.[4] ?? "-",
                      4
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_2?.[4] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_2?.[4] ?? "-",
                      4
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_1?.[4] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_1?.[4] ?? "-",
                      4
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_2?.[4] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_2?.[4] ?? "-",
                      4
                    )}
                  />
                </Col>
              </tr>
              <tr>
                <Col className="text-center">No2</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_1?.[5] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_1?.[5] ?? "-",
                      5
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_2?.[5] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_2?.[5] ?? "-",
                      5
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_1?.[5] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_1?.[5] ?? "-",
                      5
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_2?.[5] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_2?.[5] ?? "-",
                      5
                    )}
                  />
                </Col>
              </tr>
              <tr>
                <Col className="text-center">No3</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_1?.[6] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_1?.[6] ?? "-",
                      6
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_2?.[6] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_2?.[6] ?? "-",
                      6
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_1?.[6] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_1?.[6] ?? "-",
                      6
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_2?.[6] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_2?.[6] ?? "-",
                      6
                    )}
                  />
                </Col>
              </tr>
              <tr>
                <Col className="text-center">No4</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_1?.[7] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_1?.[7] ?? "-",
                      4
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_2?.[7] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_2?.[7] ?? "-",
                      4
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_1?.[7] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_1?.[7] ?? "-",
                      4
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_2?.[7] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_2?.[7] ?? "-",
                      4
                    )}
                  />
                </Col>
              </tr>
              {/*  */}
              <tr>
                <Col className="text-center" rowSpan={4}>
                  M13.5
                </Col>
                <Col className="text-center">No1</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_1?.[8] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_1?.[8] ?? "-",
                      8
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_2?.[8] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_2?.[8] ?? "-",
                      8
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_1?.[8] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_1?.[8] ?? "-",
                      8
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_2?.[8] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_2?.[8] ?? "-",
                      8
                    )}
                  />
                </Col>
              </tr>
              <tr>
                <Col className="text-center">No2</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_1?.[9] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_1?.[9] ?? "-",
                      9
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_2?.[9] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_2?.[9] ?? "-",
                      9
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_1?.[9] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_1?.[9] ?? "-",
                      9
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_2?.[9] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_2?.[9] ?? "-",
                      9
                    )}
                  />
                </Col>
              </tr>
              <tr>
                <Col className="text-center">No3</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_1?.[10] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_1?.[10] ?? "-",
                      10
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_2?.[10] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_2?.[10] ?? "-",
                      10
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_1?.[10] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_1?.[10] ?? "-",
                      10
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_2?.[10] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_2?.[10] ?? "-",
                      10
                    )}
                  />
                </Col>
              </tr>
              <tr>
                <Col className="text-center">No4</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_1?.[11] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_1?.[11] ?? "-",
                      11
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_2?.[11] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_2?.[11] ?? "-",
                      11
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_1?.[11] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_1?.[11] ?? "-",
                      11
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_2?.[11] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_2?.[11] ?? "-",
                      11
                    )}
                  />
                </Col>
              </tr>
              {/*  */}
              <tr>
                <Col className="text-center" rowSpan={4}>
                  M13.7
                </Col>
                <Col className="text-center">No1</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_1?.[12] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_1?.[12] ?? "-",
                      12
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_2?.[12] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_2?.[12] ?? "-",
                      12
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_1?.[12] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_1?.[12] ?? "-",
                      12
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_2?.[12] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_2?.[12] ?? "-",
                      12
                    )}
                  />
                </Col>
              </tr>
              <tr>
                <Col className="text-center">No2</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_1?.[13] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_1?.[13] ?? "-",
                      13
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_2?.[13] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_2?.[13] ?? "-",
                      13
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_1?.[13] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_1?.[13] ?? "-",
                      13
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_2?.[13] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_2?.[13] ?? "-",
                      13
                    )}
                  />
                </Col>
              </tr>
              <tr>
                <Col className="text-center">No3</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_1?.[14] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_1?.[14] ?? "-",
                      14
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_2?.[14] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_2?.[14] ?? "-",
                      14
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_1?.[14] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_1?.[14] ?? "-",
                      14
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_2?.[14] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_2?.[14] ?? "-",
                      14
                    )}
                  />
                </Col>
              </tr>
              <tr>
                <Col className="text-center">No4</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_1?.[15] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_1?.[15] ?? "-",
                      15
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_2?.[15] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_2?.[15] ?? "-",
                      15
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_1?.[15] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_1?.[15] ?? "-",
                      15
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_2?.[15] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_2?.[15] ?? "-",
                      15
                    )}
                  />
                </Col>
              </tr>
              {/*  */}
              <tr>
                <Col className="text-center" rowSpan={4}>
                  M14.1
                </Col>
                <Col className="text-center">No1</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_1?.[16] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_1?.[16] ?? "-",
                      16
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_2?.[16] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_2?.[16] ?? "-",
                      16
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_1?.[16] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_1?.[16] ?? "-",
                      16
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_2?.[16] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_2?.[16] ?? "-",
                      16
                    )}
                  />
                </Col>
              </tr>
              <tr>
                <Col className="text-center">No2</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_1?.[17] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_1?.[17] ?? "-",
                      17
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_2?.[17] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_2?.[17] ?? "-",
                      17
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_1?.[17] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_1?.[17] ?? "-",
                      17
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_2?.[17] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_2?.[17] ?? "-",
                      17
                    )}
                  />
                </Col>
              </tr>
              <tr>
                <Col className="text-center">No3</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_1?.[18] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_1?.[18] ?? "-",
                      18
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_2?.[18] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_2?.[18] ?? "-",
                      18
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_1?.[18] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_1?.[18] ?? "-",
                      18
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_2?.[18] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_2?.[18] ?? "-",
                      18
                    )}
                  />
                </Col>
              </tr>
              <tr>
                <Col className="text-center">No4</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_1?.[19] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_1?.[19] ?? "-",
                      19
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_9_2?.[19] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      r3_9_2?.[19] ?? "-",
                      19
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_1?.[19] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_1?.[19] ?? "-",
                      19
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_9_2?.[19] ?? "-"}
                    isInputCorrect={isInputCorrect(
                      "3-9",
                      last_r3_9_2?.[19] ?? "-",
                      19
                    )}
                  />
                </Col>
              </tr>
            </TableBody>
          </Table>
        </Card>

        <Card>
          <Table>
            <thead>
              <tr>
                <ColHeader colSpan={19}>
                  ヨーベアリング自動潤滑装置　グリース記録表
                </ColHeader>
              </tr>
              <tr>
                <ColHeader id="3-14" className="w-10 print:hidden">
                  <ResultDropdown
                    turbineInspection={turbineInspection}
                    openEdit={openEdit}
                    openObs={openObs}
                    selectedItem={i3_14}
                    selectedResult={r3_14}
                    lastTurbineInspections={lastTurbineInspections}
                    inspection={inspection}
                  />
                </ColHeader>
                <ColHeader className="text-center" colSpan={2}>
                  今回
                </ColHeader>
                <ColHeader className="text-center">
                  {lastTurbineInspections?.[0]?.inspection.name}
                </ColHeader>
                <ColHeader className="text-center">
                  {lastTurbineInspections?.[1]?.inspection.name}
                </ColHeader>
              </tr>
            </thead>
            <TableBody>
              <tr>
                <Col className="text-center print:hidden" rowSpan={5}></Col>
                <Col className="text-center">前回補充後高さ</Col>
                <Col className="text-center w-80">
                  <ResultBadge
                    result={r3_14?.childrenResults[3] ?? "-"}
                    unit={i3_14?.inspectionModelItemChildren.items?.[3].unit}
                    isInputCorrect={isInputCorrect(
                      "3-14",
                      r3_14?.childrenResults[3] ?? "-",
                      3
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_14_1?.childrenResults[3] ?? "-"}
                    unit={i3_14?.inspectionModelItemChildren.items?.[3].unit}
                    isInputCorrect={isInputCorrect(
                      "3-14",
                      last_r3_14_1?.childrenResults[3] ?? "-",
                      3
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_14_2?.childrenResults[3] ?? "-"}
                    unit={i3_14?.inspectionModelItemChildren.items?.[3].unit}
                    isInputCorrect={isInputCorrect(
                      "3-14",
                      last_r3_14_2?.childrenResults[3] ?? "-",
                      3
                    )}
                  />
                </Col>
              </tr>
              <tr>
                <Col className="text-center">補充前高さ</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_14?.childrenResults[4] ?? "-"}
                    unit={i3_14?.inspectionModelItemChildren.items?.[4].unit}
                    isInputCorrect={isInputCorrect(
                      "3-14",
                      r3_14?.childrenResults[4] ?? "-",
                      4
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_14_1?.childrenResults[4] ?? "-"}
                    unit={i3_14?.inspectionModelItemChildren.items?.[4].unit}
                    isInputCorrect={isInputCorrect(
                      "3-14",
                      last_r3_14_1?.childrenResults[4] ?? "-",
                      4
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_14_2?.childrenResults[4] ?? "-"}
                    unit={i3_14?.inspectionModelItemChildren.items?.[4].unit}
                    isInputCorrect={isInputCorrect(
                      "3-14",
                      last_r3_14_2?.childrenResults[4] ?? "-",
                      4
                    )}
                  />
                </Col>
              </tr>
              <tr>
                <Col className="text-center">補充後高さ</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_14?.childrenResults[6] ?? "-"}
                    unit={i3_14?.inspectionModelItemChildren.items?.[6].unit}
                    isInputCorrect={isInputCorrect(
                      "3-14",
                      r3_14?.childrenResults[6] ?? "-",
                      6
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_14_1?.childrenResults[6] ?? "-"}
                    unit={i3_14?.inspectionModelItemChildren.items?.[6].unit}
                    isInputCorrect={isInputCorrect(
                      "3-14",
                      last_r3_14_1?.childrenResults[6] ?? "-",
                      6
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_14_2?.childrenResults[6] ?? "-"}
                    unit={i3_14?.inspectionModelItemChildren.items?.[6].unit}
                    isInputCorrect={isInputCorrect(
                      "3-14",
                      last_r3_14_2?.childrenResults[6] ?? "-",
                      6
                    )}
                  />
                </Col>
              </tr>
              <tr>
                <Col className="text-center">補充量</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_14?.childrenResults[7] ?? "-"}
                    unit={i3_14?.inspectionModelItemChildren.items?.[7].unit}
                    isInputCorrect={isInputCorrect(
                      "3-14",
                      r3_14?.childrenResults[7] ?? "-",
                      7
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_14_1?.childrenResults[7] ?? "-"}
                    unit={i3_14?.inspectionModelItemChildren.items?.[7].unit}
                    isInputCorrect={isInputCorrect(
                      "3-14",
                      last_r3_14_1?.childrenResults[7] ?? "-",
                      7
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_14_2?.childrenResults[7] ?? "-"}
                    unit={i3_14?.inspectionModelItemChildren.items?.[7].unit}
                    isInputCorrect={isInputCorrect(
                      "3-14",
                      last_r3_14_2?.childrenResults[7] ?? "-",
                      7
                    )}
                  />
                </Col>
              </tr>
              <tr>
                <Col className="text-center">消費量</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r3_14?.childrenResults[5] ?? "-"}
                    unit={i3_14?.inspectionModelItemChildren.items?.[5].unit}
                    isInputCorrect={isInputCorrect(
                      "3-14",
                      r3_14?.childrenResults[5] ?? "-",
                      5
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_14_1?.childrenResults[5] ?? "-"}
                    unit={i3_14?.inspectionModelItemChildren.items?.[5].unit}
                    isInputCorrect={isInputCorrect(
                      "3-14",
                      last_r3_14_1?.childrenResults[5] ?? "-",
                      5
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={last_r3_14_2?.childrenResults[5] ?? "-"}
                    unit={i3_14?.inspectionModelItemChildren.items?.[5].unit}
                    isInputCorrect={isInputCorrect(
                      "3-14",
                      last_r3_14_2?.childrenResults[5] ?? "-",
                      5
                    )}
                  />
                </Col>
              </tr>
            </TableBody>
          </Table>
        </Card>
      </div>
    </div>
  );
};

export default Yaw;
